import { IDataGetRestaurantInfo, IUpdateRestaurant, TMenuContentVersion, CardBrands } from 'types';
import { createContext } from 'react';

export interface IFormMccCard {
	id: string;
	brand: Nullable<CardBrands>;
	mcc: Nullable<number>;
}
export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface IInitialFormData {
	useMenuVersion: TMenuContentVersion;
	useContentVersion: TMenuContentVersion;
	restaurantMenuVersion: string;
	restaurantContentVersion: string;
}

export interface IEditFormForClientManagerState {
	fullRestaurantInfo: Nullable<IDataGetRestaurantInfo>;
	needRefetchData: boolean;
	initialFormData: Nullable<IInitialFormData>;
	useMenuVersion: TMenuContentVersion;
	useContentVersion: TMenuContentVersion;
	customerMenuVersion: string;
	customerContentVersion: string;
	restaurantMenuVersion: string;
	restaurantContentVersion: string;
	dataForSubmit: Nullable<IUpdateRestaurant>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editFormForClientManagerInitialState: IEditFormForClientManagerState = {
	fullRestaurantInfo: null,
	needRefetchData: false,
	initialFormData: null,
	useMenuVersion: 'None',
	useContentVersion: 'None',
	customerMenuVersion: '',
	customerContentVersion: '',
	restaurantMenuVersion: '',
	restaurantContentVersion: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditFormForClientManagerContext extends IEditFormForClientManagerState {
	refetchData(value: boolean): void;
	toggleUseMenuVersion(value: TMenuContentVersion): void;
	toggleUseContentVersion(value: TMenuContentVersion): void;
	changeRestaurantMenuVersion(value: string): void;
	changeRestaurantContentVersion(value: string): void;
	setDataForSubmit(data: Nullable<IUpdateRestaurant>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const EditFormForClientManagerContext = createContext<IEditFormForClientManagerContext>({
	refetchData: () => undefined,
	toggleUseMenuVersion: () => undefined,
	toggleUseContentVersion: () => undefined,
	changeRestaurantMenuVersion: () => undefined,
	changeRestaurantContentVersion: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editFormForClientManagerInitialState,
});
